var _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNaturalgasFrontwheels2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 89,
    viewBox: "0 0 430 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 385.211,
    cy: 44.3404,
    r: 38.8393,
    fill: "black",
    stroke: "#FFC4E1",
    strokeWidth: 10.3571
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.7838,
    cy: 44.3404,
    r: 38.8393,
    fill: "black",
    stroke: "#FFC4E1",
    strokeWidth: 10.3571
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 375.481,
    cy: 44.3404,
    r: 38.8393,
    fill: "#FFC4E1",
    stroke: "black",
    strokeWidth: 10.3571
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0533,
    cy: 44.3404,
    r: 38.8393,
    fill: "#FFC4E1",
    stroke: "black",
    strokeWidth: 10.3571
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturalgasFrontwheels2);
export default __webpack_public_path__ + "static/media/naturalgas-frontwheels2.9ba4fe47459a74bcb1b33ea2b14da203.svg";
export { ForwardRef as ReactComponent };